module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAQAAABKfvVzAAAArUlEQVR4Ae3LMUoDQQCF4e8a4hbRNOJFBE+VIFpZRMtopzmAkhMErcRbLBZZBGVmGzGJNhmw2RnYKuBXvOr9+js214oeHZXdPy1NXGl8lCRzS/ug0niQ1ZrYuhZkbYxsjWyKgrS/QdqdCP6DlXNcWJUGzxqX3i3ywdoYQ0++LBxgbK3Dmzt/zdQ63Ar2SCrRVIeh1ktKKq+CgU6nouDemZkoOJF16EbtW21qoK8f5VpvkEyGyc0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/attachment.png
// module id = 966
// module chunks = 0